import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocationGroupData, ResourceInstances } from '@app/interfaces/rm/resource-instances';
import {
    CommonForm,
    EditResourceTemplateParams, ResourceTemplate, ResourceTemplateField,
    ResourceTemplateListParams, ResourceTemplateParams,
    ResourceTemplateWithPage, TemplateForm,
} from '@app/interfaces/rm/resource-template';
import { Tag } from '@app/interfaces/rm/tag';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ResourceTemplateService {
    private baseUrl = environment.api.services.rm + '/resource-template';

    constructor(private http: HttpClient) {
    }

    async find(params: ResourceTemplateListParams): Promise<ResourceTemplateWithPage> {
        return lastValueFrom(this.http.get<ResourceTemplateWithPage>(`${this.baseUrl}`, {
            params: Object.assign(params),
        }));
    }

    async add(data: ResourceTemplateParams): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}`, data));
    }

    async edit(data: EditResourceTemplateParams): Promise<void> {
        return lastValueFrom(this.http.put<void>(`${this.baseUrl}`, data));
    }

    async remove(id: number): Promise<void> {
        return lastValueFrom(this.http.delete<void>(`${this.baseUrl}`, {
            params: Object.assign({ id }),
        }));
    }

    getLocationTemplateIds(fields: ResourceTemplateField[]): number[] {
        const locationIds = fields?.filter(item => item.title === 'locationId')?.map(item => item?.defaultId ? Number(item?.defaultId) : Number(item?.defaultValue));
        return locationIds;
    }

    getEditFormCommonData(data: CommonForm): {
        labelIds: number[],
        locationGroupData: LocationGroupData
    } {
        const { labelVOS } = data;
        const resourceInstance = data?.resourceInstance || data;
        const labelIds = labelVOS && labelVOS.length > 0 ? labelVOS.map((item: Tag) => item.id) : [];
        const { location, locationLab, locationFloor, locationRoom, locationType } = resourceInstance as ResourceInstances;
        const path = location?.path ? location.path.substring(1, location.path.length - 1).split('.').map(parseFloat) : null;
        const locationArr = path ? [...path] : [];
        const locationVO = data?.locationVO;
        const locationGroupData = {
            locationIds: locationArr,
            locationLabId: locationLab?.id || locationVO?.locationLabId,
            locationFloorId: locationFloor?.id || locationVO?.locationFloorId ,
            locationRoomId: locationRoom?.id || locationVO?.locationRoomId,
            locationTypeId: locationType?.id || locationVO?.locationTypeId,
        };
        return {
            labelIds,
            locationGroupData
        };
    }

    getTemplateFormData(editData: ResourceTemplate): TemplateForm {
        const fields = editData.fields;
        const labelArr = fields?.filter(item => item.title === 'labelIds')?.map(item => item?.defaultId ? Number(item?.defaultId) : Number(item?.defaultValue));
        const labelIds = [...labelArr];
        let templateData: {
            [key: string]: string | number
        } = {};
        fields?.forEach(item => {
            const fieldName = item.resourceDefinitionFieldVO ? item.resourceDefinitionFieldVO.title : item.title;
            templateData = fieldName ? {
                ...templateData,
                [fieldName as string]: item?.defaultId ? Number(item?.defaultId) : item?.defaultValue as string
            } : {};
        });
        console.log('getTemplateFormData', templateData);
        const locationIds = this.getLocationTemplateIds(fields) as number[];
        const locationGroupData = {
            locationIds: [...locationIds],
            locationLabId: templateData?.locationLabId ? Number(templateData?.locationLabId) : undefined,
            locationFloorId: templateData?.locationFloorId ? Number(templateData?.locationFloorId) : undefined,
            locationRoomId: templateData?.locationRoomId ? Number(templateData?.locationRoomId) : undefined,
            locationTypeId: templateData?.locationTypeId ? Number(templateData?.locationTypeId) : undefined
        };
        return {
            labelIds,
            locationGroupData,
            templateData
        };
    }
}
